<template>
<div class="col q-mini-drawer-hide">
  <q-list separator class="tree tree--full-height">
    <item-link
        v-for="mapGroup in filteredMapGroups"
        :key="mapGroup.id"
        class="row items-center q-pl-md"
        :active="mapGroup.id === current"
        :label="mapGroup.title"
        :href="$route('mapgroup.edit', { kaartgroep: mapGroup.id })"
    >
      <template #after-content>
        <q-chip class="count-chip">{{ mapGroup.mapcount }}</q-chip>
      </template>
    </item-link>
  </q-list>
</div>
</template>

<script>
export default {
  props: {
    mapGroups: {
      type: Array,
      default: () => [],
    },
  },
  data () {
    return { filteredMapGroups: this.mapGroups }
  },
  computed: {
    current () {
      const id = this.$route().params.kaartgroep
      if (!id) return null
      return parseInt(id)
    },
  },
  methods: {
    doSearch (term) {
      if (!term) {
        this.filteredMapGroups = this.mapGroups
        return
      }
      this.filteredMapGroups = this.mapGroups.filter(group => group.title.toLowerCase().includes(term))
    },
  },
}
</script>
